// const mcData = require('minecraft-data')('1.16')

class InventoryManager {
  /** @type {'left' | 'right' | null} */
  mouseDown = null
  touch = false
  onJeiClick = (item, index, mouse) => {
    console.log('jei click', item, index, mouse)
  }

  constructor (/** @type {import('../lib/InventoryWindow.mjs').InventoryWindow} */win, inv, /** @type {import('mineflayer').Bot|undefined} */bot) {
    this.win = win
    this.inv = inv
    this.bot = bot
    this.map = win.getWindowMap()
    this.renderItems()
    this.disablePicking = false

    win.on('itemEvent', (id, type, pos, data) => {
      // console.log('itemEvent', id, type, pos, data)
      if (type === 'release') {
        this.onRelease()
      } else if (data[0] === 'jeiSliceSlots') {
        const [containing, index] = data
        const item = this.win.jeiSliceSlots[index]
        if (type === 'click' || type === 'rightclick') {
          if (this.win.floatingItem) {
            // todo remove item
          }
          this.onJeiClick(item, index, type === 'rightclick' ? 1 : 0)
        } else {
          this.onInventoryEvent(type, containing, index, -1, item)
        }
      } else {
        const [containing, index] = data
        const slotIndex = this.map[containing] ? this.map[containing][0] + index : -1
        const item = this.inv.slots[slotIndex]
        this.onInventoryEvent(type, containing, index, slotIndex, item)
      }
    })
  }

  setSlots (items) {
    this.inv.slots = items
    this.renderItems()
    this.win.needsUpdate = true
  }
  setSlot (inventoryIndex, item) {
    this.inv.slots[inventoryIndex] = item
    // console.log('set', inventoryIndex, item)
    this.renderItems()
    this.win.needsUpdate = true
  }

  // Called when we've updated the Prismarine-Windows inventory slots, re-render the GUI window
  renderItems () {
    for (const key in this.map) {
      const [begin, end] = this.map[key]
      this.win[key] = this.inv.slots.slice(begin, end != null ? end + 1 : undefined)
    }
    this.win.needsUpdate = true
  }

  // Helper for the max amount of items that can be filled in this slot, TODO: fill in with mcData
  getMaxStackSize (item) {
    return mcData.items[item.type].stackSize
  }

  // Called after the user has held down the mouse and has now released it
  onRelease () {
    if (this.mouseDown) {
      this.spreadFill('end', this.mouseDown === 'right')
    }
    this.mouseDown = false
    this.mouseDownSlots = null
    const { reactive } = this.win
    if (reactive.floatingItem?.count === 0) {
      reactive.floatingItem = undefined
    }
  }

  spreadFill(/** @type {'start' | 'end' | 'progress'} */type, /** @type {boolean} */isRight, slotIndex = null) {
    if (!this.bot) return
    const currentWindow = this.bot.currentWindow ?? this.bot?.inventory
    const oldAcceptClick = currentWindow.acceptClick
    currentWindow.acceptClick = () => {}
    if (type === 'start') {
      let mouseButton = isRight ? 4 : 0
      let mode = 5
      // currentWindow.selectedItem = {...currentWindow.slots[slotIndex], count: Math.ceil(currentWindow.slots[slotIndex].count / 2)}
      this.bot?.clickWindow(-999, mouseButton, mode)
      console.log('spread fill start', isRight, slotIndex)
    }
    if (type === 'end') {
      let mouseButton = isRight ? 6 : 2
      let mode = 5
      this.bot?.clickWindow(-999, mouseButton, mode)
      currentWindow.selectedItem = null
      console.log('spread fill end')
    }
    if (type === 'progress') {
      let mouseButton = isRight ? 5 : 1
      let mode = 5
      this.bot?.clickWindow(slotIndex, mouseButton, mode)
      console.log('spread fill progress', slotIndex)
    }
    currentWindow.acceptClick = oldAcceptClick
  }

  setCursorItem(index, count) {
    if (!this.bot) return
    const currentWindow = this.bot.currentWindow ?? this.bot.inventory
    currentWindow.selectedItem = {...currentWindow.slots[index], count}
  }

  onLeftClick(inventoryIndex, item) {
    if (this.mouseDown) return
    const { reactive } = this.win
    const floating = reactive.floatingItem

    if (!this.disablePicking) {
      if (floating) {
        console.log('had a floating item')
        if (item) {
          if (this.getItemKey(floating) === this.getItemKey(item)) {
            // add to existing slot
            const free = item.stackSize - item.count
            const consumable = Math.min(floating.count, free)
            floating.count -= consumable
            if (floating.count <= 0) {
              reactive.floatingItem = undefined
            }
            this.win.needsUpdate = true
          } else {
            // swap
            const old = this.inv.slots[inventoryIndex]
            this.setSlot(inventoryIndex, reactive.floatingItem)
            this.setCursorItem(inventoryIndex, old.count)
            reactive.floatingItem = old
            this.win.needsUpdate = true
          }
        } else {
          // slot is empty, set floating item to slot
          this.setSlot(inventoryIndex, reactive.floatingItem)
          reactive.floatingItem = null
          this.win.needsUpdate = true
        }
      } else if (item) { // pickup item
        reactive.floatingItem = { ...item }
        this.setSlot(inventoryIndex, null)
        this.setCursorItem(inventoryIndex, item.count)
      }
    }

    // Send to server!
    console.log('slot click', inventoryIndex)
    this.bot?.clickWindow(inventoryIndex, 0, 0)
  }

  getItemKey(item, count = false) {
    return `${item.type}:${count ? item.count : ''}:${item.nbt ? JSON.stringify(item.nbt) : ''}:${item.metadata}:${item.components ? JSON.stringify(item.components) : ''}`
  }

  onRightClick (inventoryIndex, slot, fromSpread = false) {
    const { reactive } = this.win
    const initialCount = slot?.count

    const floating = reactive.floatingItem
    if (floating) {
      if (slot) {
        const free = slot.stackSize - slot.count
        if (this.getItemKey(slot) === this.getItemKey(floating) && free >= 1) {
          floating.count--
          slot.count++
        } else {
          this.setSlot(inventoryIndex, floating)
          reactive.floatingItem = {...slot}
        }
      } else {
        floating.count--
      }
    } else if (slot) {
      reactive.floatingItem = {...slot}
      reactive.floatingItem.count = initialCount - Math.ceil(slot.count / 2)
      this.setCursorItem(inventoryIndex, reactive.floatingItem.count)
      this.setSlot(inventoryIndex, slot.count ? slot : null)
    }
    if (slot?.count === 0) delete this.inv.slots[inventoryIndex]
    // if (floating?.count === 0) delete this.win.floatingItem

    if (!fromSpread) {
      this.bot?.clickWindow(inventoryIndex, 1, 0)
    }
  }

  // Adds an item to a slot and returns how much was able to be added
  addToSlot (inventoryIndex, item, existingOnly = true) {
    const currentItem = this.inv.slots[inventoryIndex]
    if (currentItem) {
      if (currentItem.type !== item.type) return 0
      const free = currentItem.stackSize - item.count
      const amountToAdd = Math.min(item.count, free)
      if (amountToAdd <= 0) return 0
      currentItem.count += amountToAdd
      item.count -= amountToAdd
      return amountToAdd
    } else if (!existingOnly) {
      this.inv.slots[inventoryIndex] = item.clone()
      item.count = 0
      return this.inv.slots[inventoryIndex].count
    }
    return 0
  }

  /**
   *
   * @param {string} slotType - The type of ItemGrid for example the hotbar or armor bar or inventory. The variable used in layout window classes.
   * @param {number} inventoryIndex - The index in the Prismarine-Window slots sent over the network
   * @param {*} item - The item at the position of the `inventoryIndex`
   */
  onShiftClick (slotType, inventoryIndex, item) {
    if (!item) return
    this.bot?.clickWindow(inventoryIndex, 0, 1)
    // ALL BELOW COMMENTED as the server can handle the rest!

    // Shift click move item, TODO: handle edge cases:
    // if (type is armor) move to armor slot;
    // if (type is shield) move to shield slot;
    // else ...

    // const shift = (to) => {
    //   const map = this.map[to]
    //   // First, try to add to add the floating item to all the slots that match the floating item type
    //   for (let i = map[0]; i < map[1] && item.count; i++) {
    //     // const added = this.addToSlot(i, item, true)
    //     // item.count -= added
    //     if (item.count <= 0) delete this.inv.slots[inventoryIndex]
    //   }
    //   // Then if we still have remaining items, add to any empty slot
    //   for (let i = map[0]; i < map[1] && item.count; i++) {
    //     // const added = this.addToSlot(i, item, false)
    //     // item.count -= added
    //     if (item.count <= 0) delete this.inv.slots[inventoryIndex]
    //   }
    // }

    // if (slotType === 'hotbarItems') shift('inventoryItems')
    // if (slotType === 'inventoryItems') shift('hotbarItems')
    // this.renderItems()
  }

  // Called whenever an inventory event occurs
  onInventoryEvent (type, containing, windowIndex, inventoryIndex, item) {
    const floating = this.win.floatingItem
    // The user has double clicked, so collect all the items that match this type
    // until the floating (held) stack has reached is its max size
    if (type === 'doubleclick' && floating && !item) {
      // console.assert(!item)
      // Trigger normal click event first (first click picks up, second places)
      // this.onClick(containing, windowIndex, inventoryIndex, item)
      let canPickup = this.getMaxStackSize(item) - floating.count
      if (!canPickup) {
        console.log('cant pickup items')
        return
      }
      for (let i = 0; i < this.inv.slots.length && canPickup; i++) {
        const slot = this.inv.slots[i]
        if (!slot) continue
        if (floating.type === slot.type && slot.count) {
          canPickup -= slot.count
          floating.count += slot.count
          slot.count = 0

          if (canPickup <= 0) {
            floating.count -= slot.count
            floating.count += +canPickup
            slot.count += +canPickup
            canPickup = 0
          }

          if (slot.count <= 0) delete this.inv.slots[i]
        }
        this.renderItems()
      }
    } else if (type === 'click' && this.win._downKeys.has('ShiftLeft')) {
      this.onShiftClick(containing, inventoryIndex, item)
      // MULTISPREAD FILL BELOW
    } else if (type === 'click' || type === 'rightclick') {
      console.log('click with', this.win._downKeys)
      this[type === 'click' ? 'onLeftClick' : 'onRightClick'](inventoryIndex, item)
    } else if (type === 'rightmousedown' || type === 'mousedown') {
      this.mouseDownSlots = new Set([inventoryIndex])
      // starting fill
      if (this.win.reactive.floatingItem) {
        // this.mouseDown = type === 'rightmousedown' ? 'right' : 'left'
        // this.spreadFill('start', this.mouseDown === 'right', inventoryIndex)
      }
    } else if (type === 'hover') {
      if (this.win.reactive.floatingItem && this.mouseDown) {
        if (this.mouseDown === 'left') {
          // multi spread operation
          if (this.mouseDownSlots.has(inventoryIndex) || item) return
          this.mouseDownSlots.add(inventoryIndex)
          const dividend = Math.floor(this.win.reactive.floatingItem.count / this.mouseDownSlots.size)
          if (!dividend) return
          let accounted = this.win.reactive.floatingItem.count
          for (const slotIndex of this.mouseDownSlots) {
            let val = this.inv.slots[slotIndex]
            if (!val) {
              this.inv.slots[slotIndex] = {...this.win.reactive.floatingItem}
              val = this.inv.slots[slotIndex]
            }
            val.count = dividend
            accounted = accounted - dividend
          }
          this.win.reactive.floatingItem.count = accounted
          this.spreadFill('progress', this.mouseDown === 'right', inventoryIndex)
          this.renderItems()
        } else if (this.mouseDown === 'right') {
          // single spread operation
          if (this.mouseDownSlots.has(inventoryIndex)) return
          this.onRightClick(inventoryIndex, item, true)
          this.mouseDownSlots.add(inventoryIndex)
          this.spreadFill('progress', this.mouseDown === 'right', inventoryIndex)
        }
      }
    }
  }
}

export class Item {
  constructor (type, count, isBlock) {
    this.type = type
    this.count = count
    this.displayName = type
    this.stackSize = 64
    if(isBlock) {
      this.blockData = {
        left: {
          type
        },
        right: {
          type
        },
        top: {
          type
        }
      }
    }
  }

  clone () {
    return new Item(this.type, this.count)
  }
}

class InventoryDataProvider {
  slots = [
    new Item(2, 22),
    new Item(3, 18),
    new Item(4, 16, true),
    new Item(5, 15)
  ]

  firstEmptySlotRange (start, end) {
    for (let i = start; i < end; ++i) {
      if (!this.slots[i]) return i
    }
    return null
  }

  firstEmptyHotbarSlot () {
    return this.firstEmptySlotRange(this.hotbarStart, this.inventoryEnd)
  }

  firstEmptyContainerSlot () {
    return this.firstEmptySlotRange(0, this.inventoryStart)
  }
}

export default (inventory, /** @type {import('mineflayer').Bot|undefined} */bot) => {
  const provider = new InventoryDataProvider()

  return new InventoryManager(inventory, provider, bot)
}


// function createWindowView(pwindow) {
//   let windows = {}
//   windows['minecraft:inventory'] = { clas: PlayerInventory }
// }
